import axios, { AxiosRequestConfig } from 'axios';
import { useCallback, useState } from 'react';

interface DownloadResourceResponse {
  fileName: string;
  file: string;
}

interface DownloadResource {
  filename: string;
  blobFile: Blob;
}

const base64ToBlob = (base64String: string, contentType = '') => {
  const byteCharacters = atob(base64String);
  const byteArrays = [];

  for (let i = 0; i < byteCharacters.length; i += 1) {
    byteArrays.push(byteCharacters.charCodeAt(i));
  }

  const byteArray = new Uint8Array(byteArrays);
  return new Blob([byteArray], { type: contentType });
};

export const useDownloadBase64Resource = (
  requestProps: AxiosRequestConfig = {
    method: 'post',
  },
) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<any | null>(null);

  const downloadResource = useCallback(
    async ({
      url,
      payload,
      params,
    }: {
      url: string;
      payload?: any;
      params?: any;
    }): Promise<DownloadResource | null> => {
      try {
        setError(null);
        setLoading(true);
        const response = await axios({
          url,
          data: payload,
          params,
          ...requestProps,
        });
        const fileResponse = response.data as DownloadResourceResponse;

        setLoading(false);
        return {
          blobFile: base64ToBlob(fileResponse.file),
          filename: fileResponse.fileName,
        };
      } catch (e) {
        setError(e);
        setLoading(false);
        console.error('Error downloading the selected file', e);
        return null;
      }
    },
    [requestProps],
  );

  return {
    loading,
    downloadResource,
    error,
  };
};
